let intersect = function (entries) {
    for (let entry of entries) {
        if (entry.isIntersecting && !entry.target.classList.contains('animate')) {
            entry.target.classList.add('animate')
        }
    }
}

const headerHeight = (window.innerWidth < 768) ? '74px' : '86px';
const observer = new IntersectionObserver(intersect, {
    threshold: .5,
    rootMargin: headerHeight + ' 0px 0px 0px'
});
document.querySelectorAll('.animation-trigger, .fade-in').forEach(element => {
    observer.observe(element);
});
